module.exports = __webpack_public_path__ + "static/media/introTeamsServices.6de2ec8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/introTeamsServices.jpg
// module id = 858
// module chunks = 9